export default {
  ranks: ['a', 'k', 'q', 'j', 't', '9', '8', '7', '6', '5', '4', '3', '2'],
  suits: ['c', 's', 'h', 'd'],
  broadwayRanks: ['a', 'k', 'q', 'j', 't'],
  nonBroadwayRanks: ['9', '8', '7', '6', '5', '4', '3', '2'],
  coordinatedMiddleFlopRanks: ['987', '986', '976', '876', '875', '865', '765', '764', '754'],
  coordinatedSmallFlopRanks: ['654', '653', '643', '543', '542', '532', '432'],
  bingoFlopRanks: ['aaa', 'kkk', 'qqq', 'jjj', 'ttt', '999', '888', '777', '666', '555', '444', '333', '222'],
  combos: [
    'cc', 'cs', 'ch', 'cd',
    'sc', 'ss', 'sh', 'sd',
    'hc', 'hs', 'hh', 'hd',
    'dc', 'ds', 'dh', 'dd'
  ],
  handRankings: {
    // http://www.newsmth.net/bbsanc.php?path=/groups/sport.faq/Poker/pikeziliao/M.1288254660.S0&ap=641189
    'sklansky-chubukov': [
      'aa', 'kk', 'aks', 'qq', 'ako', 'jj', 'aqs', 'tt', 'aqo', '99', 'ajs', '88', 'ats', 'ajo',
      '77', '66', 'ato', 'a9s', '55', 'a8s', 'kqs', '44', 'a9o', 'a7s', 'kjs', 'a5s', 'a8o', 'a6s',
      'a4s', '33', 'kts', 'a7o', 'a3s', 'kqo', 'a2s', 'a5o', 'a6o', 'a4o', 'kjo', 'qjs', 'a3o',
      '22', 'k9s', 'a2o', 'kto', 'qts', 'k8s', 'k7s', 'jts', 'k9o', 'k6s', 'qjo', 'q9s', 'k5s',
      'k8o', 'k4s', 'qto', 'k7o', 'k3s', 'k2s', 'q8s', 'k6o', 'j9s', 'k5o', 'q9o', 'jto', 'k4o',
      'q7s', 't9s', 'q6s', 'k3o', 'j8s', 'q5s', 'k2o', 'q8o', 'q4s', 'j9o', 'q3s', 't8s', 'j7s',
      'q7o', 'q2s', 'q6o', '98s', 'q5o', 'j8o', 't9o', 'j6s', 't7s', 'j5s', 'q4o', 'j4s', 'j7o',
      'q3o', '97s', 't8o', 'j3s', 't6s', 'q2o', 'j2s', '87s', 'j6o', '98o', 't7o', '96s', 'j5o',
      't5s', 't4s', '86s', 'j4o', 't6o', '97o', 't3s', '76s', '95s', 'j3o', 't2s', '87o', '85s',
      '96o', 't5o', 'j2o', '75s', '94s', 't4o', '65s', '86o', '93s', '84s', '95o', 't3o', '76o',
      '92s', '74s', '54s', 't2o', '85o', '64s', '83s', '94o', '75o', '82s', '73s', '93o', '65o',
      '53s', '63s', '84o', '92o', '43s', '74o', '72s', '54o', '64o', '52s', '62s', '83o', '42s',
      '82o', '73o', '53o', '63o', '32s', '43o', '72o', '52o', '62o', '42o', '32o'
    ],

    // https://www.tightpoker.com/poker_hands.html
    'expected-value': [
      'aa', 'kk', 'qq', 'jj', 'aks', 'aqs', 'tt', 'ako', 'ajs', 'kqs', '99', 'ats', 'aqo',
      'kjs', '88', 'qjs', 'kts', 'a9s', 'ajo', 'qts', 'kqo', '77', 'jts', 'a8s', 'k9s',
      'ato', 'a5s', 'a7s', 'kjo', '66', 't9s', 'a4s', 'q9s', 'j9s', 'qjo', 'a6s', '55',
      'a3s', 'k8s', 'kto', '98s', 't8s', 'k7s', 'a2s', '87s', 'qto', 'q8s', '44', 'a9o',
      'j8s', '76s', 'jto', '97s', 'k6s', 'k5s', 'k4s', 't7s', 'q7s', 'k9o', '65s', 't9o',
      '86s', 'a8o', 'j7s', '33', '54s', 'q6s', 'k3s', 'q9o', '75s', '22', 'j9o', '64s',
      'q5s', 'k2s', '96s', 'q3s', 'j8o', '98o', 't8o', '97o', 'a7o', 't7o', 'q4s', 'q8o',
      'j5s', 't6o', '75o', 'j4s', '74s', 'k8o', '86o', '53s', 'k7o', '63s', 'j6s', '85o',
      't6s', '76o', 'a6o', 't2o', '95s', '84o', '62o', 't5s', '95o', 'a5o', 'q7o', 't5o',
      '87o', '83o', '65o', 'q2s', '94o', '74o', '54o', 'a4o', 't4o', '82o', '64o', '42o',
      'j7o', '93o', '85s', '73o', '53o', 't3o', '63o', 'k6o', 'j6o', '96o', '92o', '72o',
      '52o', 'q4o', 'k5o', 'j5o', '43s', 'q3o', '43o', 'k4o', 'j4o', 't4s', 'q6o', 'q2o',
      'j3s', 'j3o', 't3s', 'a3o', 'q5o', 'j2o', '84s', '82s', '42s', '93s', '73s', 'k3o',
      'j2s', '92s', '52s', 'k2o', 't2s', '62s', '32o', 'a2o', '83s', '94s', '72s', '32s'
    ],

    // https://www.gamblingsites.org/poker/texas-holdem/starting-hand-rankings/
    'all-in-9-handed': [
      'aa', 'kk', 'qq', 'aks', 'jj', 'aqs', 'kqs', 'ajs', 'kjs', 'tt', 'ako', 'ats',
      'qjs', 'kts', 'qts', 'jts', '99', 'aqo', 'a9s', 'kqo', '88', 'k9s', 't9s', 'a8s',
      'q9s', 'j9s', 'ajo', 'a5s', '77', 'a7s', 'kjo', 'a4s', 'a3s', 'a6s', 'qjo', '66',
      'k8s', 't8s', 'a2s', '98s', 'j8s', 'ato', 'q8s', 'k7s', 'kto', '55', 'jto', '87s',
      'qto', '44', '33', '22', 'k6s', '97s', 'k5s', '76s', 't7s', 'k4s', 'k3s',
      'k2s', 'q7s', '86s', '65s', 'j7s', '54s', 'q6s', '75s', '96s', 'q5s', '64s', 'q4s',
      'q3s', 't9o', 't6s', 'q2s', 'a9o', '53s', '85s', 'j6s', 'j9o', 'k9o', 'j5s', 'q9o',
      '43s', '74s', 'j4s', 'j3s', '95s', 'j2s', '63s', 'a8o', '52s', 't5s', '84s', 't4s',
      't3s', '42s', 't2s', '98o', 't8o', 'a5o', 'a7o', '73s', 'a4o', '32s', '94s', '93s',
      'j8o', 'a3o', '62s', '92s', 'k8o', 'a6o', '87o', 'q8o', '83s', 'a2o', '82s', '97o',
      '72s', '76o', 'k7o', '65o', 't7o', 'k6o', '86o', '54o', 'k5o', 'j7o', '75o', 'q7o',
      'k4o', 'k3o', '96o', 'k2o', '64o', 'q6o', '53o', '85o', 't6o', 'q5o', '43o', 'q4o',
      'q3o', '74o', 'q2o', 'j6o', '63o', 'j5o', '95o', '52o', 'j4o', 'j3o', '42o', 'j2o',
      '84o', 't5o', 't4o', '32o', 't3o', '73o', 't2o', '62o', '94o', '93o', '92o', '83o',
      '82o', '72o'
    ],

    // https://wizardofodds.com/games/texas-hold-em/3-player-game/
    'all-in-3-handed': [
      'aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', '88', 'aqs', 'ako', 'ajs', 'kqs', 'ats',
      'aqo', '77', 'kjs', 'ajo', 'kts', 'a9s', 'kqo', 'ato', 'qjs', 'a8s', '66', 'qts',
      'kjo', 'a7s', 'k9s', 'jts', 'kto', 'a9o', 'a5s', 'qjo', 'a6s', 'q9s', 'a4s', 'a8o',
      'qto', 'k8s', '55', 'a3s', 'j9s', 'k7s', 'a7o', 'k9o', 'jto', 'a2s', 't9s', 'q8s',
      'k6s', 'a5o', 'a6o', 'q9o', 'k5s', 'j8s', 'a4o', 'k8o', '44', 't8s', 'k4s', 'q7s',
      'j9o', 'a3o', 'k7o', '98s', 'q6s', 'k3s', 't9o', 'j7s', 'q8o', 'a2o', 'k6o', 'k2s',
      'q5s', 't7s', 'j8o', '97s', 'q4s', 'k5o', '87s', '33', 't8o', 'j6s', 'q3s', 'q7o',
      'k4o', 'j5s', '98o', 't6s', 'q2s', 'q6o', '96s', 'k3o', '86s', 'j7o', '76s', 'j4s',
      'q5o', 't7o', 'k2o', 'j3s', 't5s', '97o', '22', '87o', 'q4o', 'j2s', '65s', '95s',
      't4s', '75s', '85s', 'j6o', 'q3o', 't3s', 't6o', 'j5o', '54s', 't2s', 'q2o', '96o',
      '64s', '86o', '76o', '94s', '74s', 'j4o', '84s', '93s', 'j3o', '53s', 't5o', '92s',
      '65o', '63s', '95o', 'j2o', '75o', 't4o', '43s', '85o', '73s', '83s', '82s', 't3o',
      '52s', '54o', '62s', '64o', 't2o', '42s', '72s', '94o', '74o', '84o', '93o', '32s',
      '53o', '92o', '63o', '43o', '73o', '83o', '82o', '52o', '62o', '42o', '72o', '32o'
    ],

    // http://www.propokertools.com/orderings/hevsrandomordering.txt
    'all-in-heads-up': [
      'aa', 'kk', 'qq', 'jj', 'tt', '99', '88', 'aks', '77', 'aqs', 'ajs', 'ako', 'ats',
      'aqo', 'ajo', 'kqs', '66', 'a9s', 'ato', 'kjs', 'a8s', 'kts', 'kqo', 'a7s', 'a9o',
      'kjo', '55', 'qjs', 'k9s', 'a5s', 'a6s', 'a8o', 'kto', 'qts', 'a4s', 'a7o', 'k8s',
      'a3s', 'qjo', 'k9o', 'a5o', 'a6o', 'q9s', 'k7s', 'jts', 'a2s', 'qto', '44', 'a4o',
      'k6s', 'k8o', 'q8s', 'a3o', 'k5s', 'j9s', 'q9o', 'jto', 'k7o', 'a2o', 'k4s', 'q7s',
      'k6o', 'k3s', 't9s', 'j8s', '33', 'q6s', 'q8o', 'k5o', 'j9o', 'k2s', 'q5s', 't8s',
      'k4o', 'j7s', 'q4s', 'q7o', 't9o', 'j8o', 'k3o', 'q6o', 'q3s', '98s', 't7s', 'j6s',
      'k2o', '22', 'q2s', 'q5o', 'j5s', 't8o', 'j7o', 'q4o', '97s', 'j4s', 't6s', 'j3s',
      'q3o', '98o', '87s', 't7o', 'j6o', '96s', 'j2s', 'q2o', 't5s', 'j5o', 't4s', '97o',
      '86s', 'j4o', 't6o', '95s', 't3s', '76s', 'j3o', '87o', 't2s', '85s', '96o', 'j2o',
      't5o', '94s', '75s', 't4o', '93s', '86o', '65s', '84s', '95o', 't3o', '92s', '76o',
      '74s', 't2o', '54s', '85o', '64s', '83s', '94o', '75o', '82s', '73s', '93o', '65o',
      '53s', '63s', '84o', '92o', '43s', '74o', '72s', '54o', '64o', '52s', '62s', '83o',
      '42s', '82o', '73o', '53o', '63o', '32s', '43o', '72o', '52o', '62o', '42o', '32o'
    ],

    // http://www.propokertools.com/orderings/heordering.txt
    'ten-handed-evolutionary': [
      'aa', 'kk', 'qq', 'jj', 'aks', 'tt', 'ako', 'aqs', '99', 'ajs', 'aqo', '88', 'ats',
      'kqs', 'ajo', '77', 'kjs', 'qjs', 'kts', 'kqo', 'a9s', 'ato', '66', 'a8s', 'qts',
      'jts', 'kjo', 'a7s', 'a5s', 'k9s', 'a4s', 'a6s', '55', 'q9s', 'a3s', 'j9s', 'kto',
      'qjo', 'a9o', 't9s', 'k8s', 'a2s', 'k7s', '44', 'a8o', 'qto', 'q8s', 'jto', 'j8s',
      'k6s', '98s', 't8s', 'k5s', 'a7o', 'k4s', 'k9o', 'a5o', '33', 'k3s', 'a4o', 'q9o',
      '87s', 'q7s', 't7s', 'q6s', 'k2s', 'j7s', 'a6o', '97s', 'q5s', 'a3o', 'j9o', 't9o',
      '22', 'k8o', 'a2o', 'q4s', '76s', 'k7o', '86s', '96s', 'j6s', 'j5s', 'k6o', 'q3s',
      'q2s', 't6s', '65s', 'k5o', '75s', 'q8o', '54s', 'j8o', 'j4s', 't8o', '98o', '85s',
      '95s', 'k4o', 'j3s', '64s', 't4s', 't5s', '87o', 'q7o', 'k3o', 'j2s', '74s', '97o',
      'j7o', '53s', 'q6o', 't3s', 'k2o', '94s', 't7o', '84s', '43s', '63s', 'q5o', '86o',
      't2s', '93s', '76o', 'q4o', '92s', '96o', '73s', 'j6o', 'q3o', '52s', '65o', 'j5o',
      't6o', '82s', '42s', '83s', 'q2o', '75o', '54o', 'j4o', '62s', '85o', '32s', '95o',
      '72s', 'j3o', 't5o', 't4o', '64o', 'j2o', '53o', '74o', '84o', 't3o', '43o', '94o',
      't2o', '93o', '63o', '92o', '73o', '52o', '42o', '83o', '82o', '62o', '32o', '72o'
    ],

    // http://www.propokertools.com/orderings/he6maxordering.txt
    'six-handed-evolutionary': [
      'aa', 'kk', 'qq', 'jj', 'tt', 'aks', 'ako', 'aqs', '99', 'ajs', 'aqo', '88', 'ats',
      'ajo', 'kqs', '77', 'kjs', 'ato', 'kqo', 'a9s', 'kts', '66', 'a8s', 'qjs', 'a7s',
      'kjo', 'qts', 'a5s', 'a9o', 'a6s', 'jts', '55', 'k9s', 'a4s', 'kto', 'a3s', 'a8o',
      'qjo', 'q9s', 'a2s', 'k8s', 'j9s', '44', 'k7s', 't9s', 'qto', 'a7o', 'k6s', 'a5o',
      'jto', 'q8s', 'k9o', 'a6o', 'k5s', 'j8s', 't8s', 'a4o', '33', '98s', 'k4s', 'a3o',
      'q7s', 'q6s', 'q9o', 'k3s', 'k2s', 'a2o', 'j7s', 'k8o', 'j9o', 't7s', '87s', 't9o',
      'q5s', '97s', 'k7o', '22', 'q4s', 'k6o', 'j6s', 'q8o', '86s', '76s', 't6s', 'q3s',
      'k5o', '96s', 'j8o', 'j5s', 't8o', 'q2s', '98o', 'k4o', '65s', 'j4s', 'q7o', '75s',
      'q6o', 'j3s', 'k3o', 'j7o', '95s', '85s', 't5s', 't7o', 'k2o', '87o', '54s', 'j2s',
      '97o', 'q5o', 't4s', '64s', 't3s', '74s', 'q4o', '76o', 'j6o', '84s', 't2s', '94s',
      't6o', '53s', 'q3o', '86o', 'j5o', '93s', '96o', 'q2o', '63s', '92s', '65o', '43s',
      'j4o', '73s', '75o', '83s', '52s', 'j3o', '85o', 't5o', '82s', '95o', '54o', 'j2o',
      '42s', 't4o', '62s', '64o', '72s', '32s', 't3o', '74o', '84o', 't2o', '53o', '94o',
      '93o', '43o', '63o', '92o', '73o', '83o', '52o', '82o', '42o', '62o', '72o','32o'
    ],

    // http://www.propokertools.com/orderings/he3maxordering.txt
    'three-handed-evolutionary': [
      'aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', 'aqs', '88', 'ako', 'ajs', 'aqo', 'ats',
      '77', 'ajo', 'kqs', 'ato', 'a9s', 'kjs', '66', 'a8s', 'kts', 'kqo', 'a7s', 'a9o',
      'qjs', 'kjo', 'a6s', 'a5s', 'a8o', '55', 'qts', 'k9s', 'kto', 'a4s', 'a7o', 'jts',
      'qjo', 'a3s', 'a2s', 'k8s', 'q9s', 'a5o', 'qto', 'a6o', '44', 'k9o', 'k7s', 'j9s',
      'a4o', 'k6s', 'jto', 'a3o', 'q8s', 't9s', 'k5s', 'k8o', 'q9o', 'a2o', 'k4s', 'j8s',
      '33', 'k7o', 'q7s', 't8s', 'k3s', 'j9o', 'q6s', 'k6o', 'q8o', 'k2s', 't9o', '98s',
      'q5s', 'j7s', 'k5o', 'q4s', 't7s', 'j8o', 'k4o', '97s', '22', 'j6s', 'q7o', 'j5s',
      'q3s', '87s', 't8o', 'k3o', 't6s', 'q6o', 'q2s', '98o', 'j4s', 'k2o', 'j7o', 'q5o',
      '96s', 'j3s', '86s', '76s', 't7o', 'q4o', 't5s', 'j2s', '97o', 'j6o', 't4s', '95s',
      'q3o', '87o', '85s', 'j5o', 't3s', '65s', '75s', 't6o', 'q2o', 't2s', 'j4o', '96o',
      '54s', '94s', '86o', 'j3o', '84s', '76o', '74s', '64s', '93s', 't5o', '92s', 'j2o',
      't4o', '95o', '53s', '85o', '75o', 't3o', '73s', '65o', '63s', '83s', '82s', '43s',
      't2o', '54o', '94o', '52s', '84o', '64o', '72s', '62s', '74o', '93o', '42s', '92o',
      '32s', '53o', '83o', '63o', '73o', '82o', '43o', '52o', '62o', '72o', '42o','32o'
    ],

    // http://www.propokertools.com/orderings/heequitysquaredordering.txt
    'heads-up-equity-squared': [
      'aa', 'kk', 'qq', 'jj', 'tt', '99', 'aks', '88', 'aqs', 'ako', 'ajs', 'ats', 'kqs',
      'aqo', '77', 'kjs', 'ajo', 'kts', 'a9s', 'kqo', 'ato', 'qjs', 'a8s', '66', 'kjo',
      'qts', 'a7s', 'k9s', 'kto', 'jts', 'a9o', 'a5s', 'qjo', 'a6s', 'q9s', 'a4s', 'a8o',
      '55', 'qto', 'k8s', 'a3s', 'j9s', 'a7o', 'k7s', 'k9o', 'jto', 'a2s', 't9s', 'q8s',
      'k6s', 'a5o', 'a6o', 'q9o', 'k5s', 'j8s', 'a4o', 'k8o', '44', 't8s', 'k4s', 'q7s',
      'a3o', 'j9o', 'k7o', '98s', 'k3s', 'q6s', 't9o', 'a2o', 'j7s', 'q8o', 'k6o', 'k2s',
      'q5s', 't7s', 'j8o', 'q4s', 'k5o', '97s', '33', '87s', 't8o', 'j6s', 'q3s', 'q7o',
      'k4o', 'j5s', '98o', 't6s', 'q2s', 'q6o', 'k3o', '96s', 'j7o', 'j4s', '86s', '76s',
      'q5o', 'k2o', 't7o', 'j3s', '22', 't5s', '97o', 'q4o', 'j2s', '87o', '95s', 't4s',
      '65s', '75s', '85s', 'j6o', 'q3o', 't3s', 'j5o', 't6o', '54s', 'q2o', 't2s', '96o',
      '64s', '86o', '76o', '94s', 'j4o', '74s', '84s', '93s', 'j3o', '53s', 't5o', '92s',
      '65o', '63s', 'j2o', '95o', 't4o', '75o', '85o', '73s', '43s', '83s', '82s', 't3o',
      '52s', '54o', 't2o', '62s', '64o', '42s', '94o', '72s', '74o', '84o', '93o', '32s',
      '53o', '92o', '63o', '43o', '73o', '83o', '82o', '52o', '62o', '42o', '72o','32o'
    ],

    'short-deck-all-in-5-handed': [
      'aa', 'kk', 'qq', 'jts', 'jj', 'aks', 'qjs', 'kqs', 'qts', 'kjs', 'aqs', 'jto', 'tt',
      'kts', 'ajs', 'ako', 'qjo', 'kqo', 't9s', 'ats', 'qto', 'kjo', 'aqo', 'kto', 'ajo',
      'j9s', '99', 't9o', 'ato', 'a9s', 't8s', 'q9s', '98s', 'a8s', 'k9s', '88', 'j9o',
      'j8s', 'a7s', '97s', 't8o', 'a9o', 't7s', '77', 'q8s', 'q9o', '98o', 'a6s', 'k8s',
      'a8o', 'k9o', '87s', 'j7s', '66', 'k7s', 'j8o', '96s', 't6s', 'a7o', 'q7s', 'k6s',
      't7o', '97o', 'q8o', '86s','q6s', 'j6s', 'k8o', 'a6o', 'j7o', '87o', '76s', 'k7o',
      '96o', 't6o', 'q7o', 'k6o', '86o', 'q6o', 'j6o', '76o'
    ],

    'short-deck-all-in-heads-up': [
      'aa', 'kk', 'qq', 'jj', 'tt', 'aks', 'aqs', 'ako', 'ajs', 'kqs', 'aqo', 'ajo', 'ats',
      'kjs', 'qjs', 'kts', 'kqo', 'qts', 'jts', '99', 'ato', 'kjo', 'qjo', 'a9s', 'kto',
      'jto', 'qto', 'a8s', 'a9o', 'k9s', 'a8o', 't9s', 'q9s', 'a7s', 'j9s', 'k9o', 't9o',
      'q9o', 'j9o', '88', 'a7o', 'a6s', 'k8s', '98s', 't8s', 'q8s', 'j8s', 'k7s', 'a6o',
      'k8o', 't8o', '98o', 'q8o', 'j8o', 'k7o', 'k6s', '97s', 't7s', 'q7s', 'j7s', '77',
      'q6s', 'k6o', '97o', 't7o', 'q7o', '87s', 'j7o', '96s', 'q6o', 't6s', 'j6s', '87o',
      '96o', '86s', 't6o', 'j6o', '66', '86o', '76s', '76o'
    ],
  },
  gridOfGeneralHandStrings: [
    [
      'aa',
      'aks',
      'aqs',
      'ajs',
      'ats',
      'a9s',
      'a8s',
      'a7s',
      'a6s',
      'a5s',
      'a4s',
      'a3s',
      'a2s',
    ], [
      'ako',
      'kk',
      'kqs',
      'kjs',
      'kts',
      'k9s',
      'k8s',
      'k7s',
      'k6s',
      'k5s',
      'k4s',
      'k3s',
      'k2s',
    ], [
      'aqo',
      'kqo',
      'qq',
      'qjs',
      'qts',
      'q9s',
      'q8s',
      'q7s',
      'q6s',
      'q5s',
      'q4s',
      'q3s',
      'q2s',
    ], [
      'ajo',
      'kjo',
      'qjo',
      'jj',
      'jts',
      'j9s',
      'j8s',
      'j7s',
      'j6s',
      'j5s',
      'j4s',
      'j3s',
      'j2s',
    ], [
      'ato',
      'kto',
      'qto',
      'jto',
      'tt',
      't9s',
      't8s',
      't7s',
      't6s',
      't5s',
      't4s',
      't3s',
      't2s',
    ], [
      'a9o',
      'k9o',
      'q9o',
      'j9o',
      't9o',
      '99',
      '98s',
      '97s',
      '96s',
      '95s',
      '94s',
      '93s',
      '92s',
    ], [
      'a8o',
      'k8o',
      'q8o',
      'j8o',
      't8o',
      '98o',
      '88',
      '87s',
      '86s',
      '85s',
      '84s',
      '83s',
      '82s',
    ], [
      'a7o',
      'k7o',
      'q7o',
      'j7o',
      't7o',
      '97o',
      '87o',
      '77',
      '76s',
      '75s',
      '74s',
      '73s',
      '72s',
    ], [
      'a6o',
      'k6o',
      'q6o',
      'j6o',
      't6o',
      '96o',
      '86o',
      '76o',
      '66',
      '65s',
      '64s',
      '63s',
      '62s',
    ], [
      'a5o',
      'k5o',
      'q5o',
      'j5o',
      't5o',
      '95o',
      '85o',
      '75o',
      '65o',
      '55',
      '54s',
      '53s',
      '52s',
    ], [
      'a4o',
      'k4o',
      'q4o',
      'j4o',
      't4o',
      '94o',
      '84o',
      '74o',
      '64o',
      '54o',
      '44',
      '43s',
      '42s',
    ], [
      'a3o',
      'k3o',
      'q3o',
      'j3o',
      't3o',
      '93o',
      '83o',
      '73o',
      '63o',
      '53o',
      '43o',
      '33',
      '32s',
    ], [
      'a2o',
      'k2o',
      'q2o',
      'j2o',
      't2o',
      '92o',
      '82o',
      '72o',
      '62o',
      '52o',
      '42o',
      '32o',
      '22',
    ]
  ],
  gridOfShortDeckGeneralHandStrings: [
    [
      'aa',
      'aks',
      'aqs',
      'ajs',
      'ats',
      'a9s',
      'a8s',
      'a7s',
      'a6s',
    ], [
      'ako',
      'kk',
      'kqs',
      'kjs',
      'kts',
      'k9s',
      'k8s',
      'k7s',
      'k6s',
    ], [
      'aqo',
      'kqo',
      'qq',
      'qjs',
      'qts',
      'q9s',
      'q8s',
      'q7s',
      'q6s',
    ], [
      'ajo',
      'kjo',
      'qjo',
      'jj',
      'jts',
      'j9s',
      'j8s',
      'j7s',
      'j6s',
    ], [
      'ato',
      'kto',
      'qto',
      'jto',
      'tt',
      't9s',
      't8s',
      't7s',
      't6s',
    ], [
      'a9o',
      'k9o',
      'q9o',
      'j9o',
      't9o',
      '99',
      '98s',
      '97s',
      '96s',
    ], [
      'a8o',
      'k8o',
      'q8o',
      'j8o',
      't8o',
      '98o',
      '88',
      '87s',
      '86s',
    ], [
      'a7o',
      'k7o',
      'q7o',
      'j7o',
      't7o',
      '97o',
      '87o',
      '77',
      '76s',
    ], [
      'a6o',
      'k6o',
      'q6o',
      'j6o',
      't6o',
      '96o',
      '86o',
      '76o',
      '66',
    ]
  ],
  categories: {
    pocketPairs: ['tt', '99', '88', '77', '66', '55', '44', '33', '22'],
    mediumPocketPairs: ['tt', '99', '88', '77'],
    smallPocketPairs: ['66', '55', '44', '33', '22'],
    suitedConnectors: ['t9s', '98s', '87s', '76s', '65s', '54s', '43s', '32s'],
    mediumSuitedConnectors: ['t9s', '98s', '87s', '76s'],
    smallSuitedConnectors: ['65s', '54s', '43s', '32s'],
    suitedOneGappers: ['t8s', '97s', '86s', '75s', '64s', '53s', '42s'],
    mediumSuitedOneGappers: ['t8s', '97s', '86s', '75s'],
    smallSuitedOneGappers: ['64s', '53s', '42s'],
    suitedAces: ['ats', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
    mediumSuitedAces: ['ats', 'a9s', 'a8s', 'a7s'],
    smallSuitedAces: ['a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
    suitedKings: ['kts', 'k9s', 'k8s', 'k7s','k6s', 'k5s', 'k4s', 'k3s', 'k2s'],
    mediumSuitedKings: ['kts', 'k9s', 'k8s', 'k7s'],
    smallSuitedKings: ['k6s', 'k5s', 'k4s', 'k3s', 'k2s'],
  },
  shortDeckCategories: {
    pocketPairs: ['jj', 'tt', '99', '88', '77', '66'],
    mediumPocketPairs: ['jj', 'tt', '99'],
    smallPocketPairs: ['88', '77', '66'],
    suitedConnectors: ['qjs', 'jts', 't9s', '98s', '87s', '76s'],
    mediumSuitedConnectors: ['qjs', 'jts', 't9s'],
    smallSuitedConnectors: ['98s', '87s', '76s'],
    suitedOneGappers: ['qts', 'j9s', 't8s', '97s', '86s'],
    mediumSuitedOneGappers: ['qts', 'j9s'],
    smallSuitedOneGappers: ['t8s', '97s', '86s'],
    suitedAces: ['ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s'],
    mediumSuitedAces: ['ajs', 'ats', 'a9s'],
    smallSuitedAces: ['a8s', 'a7s', 'a6s'],
    suitedKings: ['kjs', 'kts', 'k9s', 'k8s', 'k7s','k6s'],
    mediumSuitedKings: ['kjs', 'kts', 'k9s'],
    smallSuitedKings: ['k8s', 'k7s', 'k6s'],
  },
  textSelectorLists: {
    pairs: ['aa', 'kk', 'qq', 'jj', 'tt', '99', '88', '77', '66', '55', '44', '33', '22'],
    suited: {
      'a': ['aks', 'aqs', 'ajs', 'ats', 'a9s', 'a8s', 'a7s', 'a6s', 'a5s', 'a4s', 'a3s', 'a2s'],
      'k': ['kqs', 'kjs', 'kts', 'k9s', 'k8s', 'k7s', 'k6s', 'k5s', 'k4s', 'k3s', 'k2s'],
      'q': ['qjs', 'qts', 'q9s', 'q8s', 'q7s', 'q6s', 'q5s', 'q4s', 'q3s', 'q2s'],
      'j': ['jts', 'j9s', 'j8s', 'j7s', 'j6s', 'j5s', 'j4s', 'j3s', 'j2s'],
      't': ['t9s', 't8s', 't7s', 't6s', 't5s', 't4s', 't3s', 't2s'],
      '9': ['98s', '97s', '96s', '95s', '94s', '93s', '92s'],
      '8': ['87s', '86s', '85s', '84s', '83s', '82s'],
      '7': ['76s', '75s', '74s', '73s', '72s'],
      '6': ['65s', '64s', '63s', '62s'],
      '5': ['54s', '53s', '52s'],
      '4': ['43s', '42s'],
      '3': ['32s'],
    },
    offsuit: {
      'a': ['ako', 'aqo', 'ajo', 'ato', 'a9o', 'a8o', 'a7o', 'a6o', 'a5o', 'a4o', 'a3o', 'a2o'],
      'k': ['kqo', 'kjo', 'kto', 'k9o', 'k8o', 'k7o', 'k6o', 'k5o', 'k4o', 'k3o', 'k2o'],
      'q': ['qjo', 'qto', 'q9o', 'q8o', 'q7o', 'q6o', 'q5o', 'q4o', 'q3o', 'q2o'],
      'j': ['jto', 'j9o', 'j8o', 'j7o', 'j6o', 'j5o', 'j4o', 'j3o', 'j2o'],
      't': ['t9o', 't8o', 't7o', 't6o', 't5o', 't4o', 't3o', 't2o'],
      '9': ['98o', '97o', '96o', '95o', '94o', '93o', '92o'],
      '8': ['87o', '86o', '85o', '84o', '83o', '82o'],
      '7': ['76o', '75o', '74o', '73o', '72o'],
      '6': ['65o', '64o', '63o', '62o'],
      '5': ['54o', '53o', '52o'],
      '4': ['43o', '42o'],
      '3': ['32o'],
    },
  },
  generalHandStringToIndexMap: {
    'aa': 0,
    'kk': 1,
    'qq': 2,
    'jj': 3,
    'aks': 4,
    'tt': 5,
    'ako': 6,
    'aqs': 7,
    '99': 8,
    'ajs': 9,
    'aqo': 10,
    '88': 11,
    'ats': 12,
    'kqs': 13,
    'ajo': 14,
    '77': 15,
    'kjs': 16,
    'qjs': 17,
    'kts': 18,
    'kqo': 19,
    'a9s': 20,
    'ato': 21,
    '66': 22,
    'a8s': 23,
    'qts': 24,
    'jts': 25,
    'kjo': 26,
    'a7s': 27,
    'a5s': 28,
    'k9s': 29,
    'a4s': 30,
    'a6s': 31,
    '55': 32,
    'q9s': 33,
    'a3s': 34,
    'j9s': 35,
    'kto': 36,
    'qjo': 37,
    'a9o': 38,
    't9s': 39,
    'k8s': 40,
    'a2s': 41,
    'k7s': 42,
    '44': 43,
    'a8o': 44,
    'qto': 45,
    'q8s': 46,
    'jto': 47,
    'j8s': 48,
    'k6s': 49,
    '98s': 50,
    't8s': 51,
    'k5s': 52,
    'a7o': 53,
    'k4s': 54,
    'k9o': 55,
    'a5o': 56,
    '33': 57,
    'k3s': 58,
    'a4o': 59,
    'q9o': 60,
    '87s': 61,
    'q7s': 62,
    't7s': 63,
    'q6s': 64,
    'k2s': 65,
    'j7s': 66,
    'a6o': 67,
    '97s': 68,
    'q5s': 69,
    'a3o': 70,
    'j9o': 71,
    't9o': 72,
    '22': 73,
    'k8o': 74,
    'a2o': 75,
    'q4s': 76,
    '76s': 77,
    'k7o': 78,
    '86s': 79,
    '96s': 80,
    'j6s': 81,
    'j5s': 82,
    'k6o': 83,
    'q3s': 84,
    'q2s': 85,
    't6s': 86,
    '65s': 87,
    'k5o': 88,
    '75s': 89,
    'q8o': 90,
    '54s': 91,
    'j8o': 92,
    'j4s': 93,
    't8o': 94,
    '98o': 95,
    '85s': 96,
    '95s': 97,
    'k4o': 98,
    'j3s': 99,
    '64s': 100,
    't4s': 101,
    't5s': 102,
    '87o': 103,
    'q7o': 104,
    'k3o': 105,
    'j2s': 106,
    '74s': 107,
    '97o': 108,
    'j7o': 109,
    '53s': 110,
    'q6o': 111,
    't3s': 112,
    'k2o': 113,
    '94s': 114,
    't7o': 115,
    '84s': 116,
    '43s': 117,
    '63s': 118,
    'q5o': 119,
    '86o': 120,
    't2s': 121,
    '93s': 122,
    '76o': 123,
    'q4o': 124,
    '92s': 125,
    '96o': 126,
    '73s': 127,
    'j6o': 128,
    'q3o': 129,
    '52s': 130,
    '65o': 131,
    'j5o': 132,
    't6o': 133,
    '82s': 134,
    '42s': 135,
    '83s': 136,
    'q2o': 137,
    '75o': 138,
    '54o': 139,
    'j4o': 140,
    '62s': 141,
    '85o': 142,
    '32s': 143,
    '95o': 144,
    '72s': 145,
    'j3o': 146,
    't5o': 147,
    't4o': 148,
    '64o': 149,
    'j2o': 150,
    '53o': 151,
    '74o': 152,
    '84o': 153,
    't3o': 154,
    '43o': 155,
    '94o': 156,
    't2o': 157,
    '93o': 158,
    '63o': 159,
    '92o': 160,
    '73o': 161,
    '52o': 162,
    '42o': 163,
    '83o': 164,
    '82o': 165,
    '62o': 166,
    '32o': 167,
    '72o': 168,
  },
  specificHandStrings: [
    'acas',
    'acah',
    'acad',
    'asah',
    'asad',
    'ahad',
    'kcks',
    'kckh',
    'kckd',
    'kskh',
    'kskd',
    'khkd',
    'qcqs',
    'qcqh',
    'qcqd',
    'qsqh',
    'qsqd',
    'qhqd',
    'jcjs',
    'jcjh',
    'jcjd',
    'jsjh',
    'jsjd',
    'jhjd',
    'ackc',
    'asks',
    'ahkh',
    'adkd',
    'tcts',
    'tcth',
    'tctd',
    'tsth',
    'tstd',
    'thtd',
    'acks',
    'ackh',
    'ackd',
    'askc',
    'askh',
    'askd',
    'ahkc',
    'ahks',
    'ahkd',
    'adkc',
    'adks',
    'adkh',
    'acqc',
    'asqs',
    'ahqh',
    'adqd',
    '9c9s',
    '9c9h',
    '9c9d',
    '9s9h',
    '9s9d',
    '9h9d',
    'acjc',
    'asjs',
    'ahjh',
    'adjd',
    'acqs',
    'acqh',
    'acqd',
    'asqc',
    'asqh',
    'asqd',
    'ahqc',
    'ahqs',
    'ahqd',
    'adqc',
    'adqs',
    'adqh',
    '8c8s',
    '8c8h',
    '8c8d',
    '8s8h',
    '8s8d',
    '8h8d',
    'actc',
    'asts',
    'ahth',
    'adtd',
    'kcqc',
    'ksqs',
    'khqh',
    'kdqd',
    'acjs',
    'acjh',
    'acjd',
    'asjc',
    'asjh',
    'asjd',
    'ahjc',
    'ahjs',
    'ahjd',
    'adjc',
    'adjs',
    'adjh',
    '7c7s',
    '7c7h',
    '7c7d',
    '7s7h',
    '7s7d',
    '7h7d',
    'kcjc',
    'ksjs',
    'khjh',
    'kdjd',
    'qcjc',
    'qsjs',
    'qhjh',
    'qdjd',
    'kctc',
    'ksts',
    'khth',
    'kdtd',
    'kcqs',
    'kcqh',
    'kcqd',
    'ksqc',
    'ksqh',
    'ksqd',
    'khqc',
    'khqs',
    'khqd',
    'kdqc',
    'kdqs',
    'kdqh',
    'ac9c',
    'as9s',
    'ah9h',
    'ad9d',
    'acts',
    'acth',
    'actd',
    'astc',
    'asth',
    'astd',
    'ahtc',
    'ahts',
    'ahtd',
    'adtc',
    'adts',
    'adth',
    '6c6s',
    '6c6h',
    '6c6d',
    '6s6h',
    '6s6d',
    '6h6d',
    'ac8c',
    'as8s',
    'ah8h',
    'ad8d',
    'qctc',
    'qsts',
    'qhth',
    'qdtd',
    'jctc',
    'jsts',
    'jhth',
    'jdtd',
    'kcjs',
    'kcjh',
    'kcjd',
    'ksjc',
    'ksjh',
    'ksjd',
    'khjc',
    'khjs',
    'khjd',
    'kdjc',
    'kdjs',
    'kdjh',
    'ac7c',
    'as7s',
    'ah7h',
    'ad7d',
    'ac5c',
    'as5s',
    'ah5h',
    'ad5d',
    'kc9c',
    'ks9s',
    'kh9h',
    'kd9d',
    'ac4c',
    'as4s',
    'ah4h',
    'ad4d',
    'ac6c',
    'as6s',
    'ah6h',
    'ad6d',
    '5c5s',
    '5c5h',
    '5c5d',
    '5s5h',
    '5s5d',
    '5h5d',
    'qc9c',
    'qs9s',
    'qh9h',
    'qd9d',
    'ac3c',
    'as3s',
    'ah3h',
    'ad3d',
    'jc9c',
    'js9s',
    'jh9h',
    'jd9d',
    'kcts',
    'kcth',
    'kctd',
    'kstc',
    'ksth',
    'kstd',
    'khtc',
    'khts',
    'khtd',
    'kdtc',
    'kdts',
    'kdth',
    'qcjs',
    'qcjh',
    'qcjd',
    'qsjc',
    'qsjh',
    'qsjd',
    'qhjc',
    'qhjs',
    'qhjd',
    'qdjc',
    'qdjs',
    'qdjh',
    'ac9s',
    'ac9h',
    'ac9d',
    'as9c',
    'as9h',
    'as9d',
    'ah9c',
    'ah9s',
    'ah9d',
    'ad9c',
    'ad9s',
    'ad9h',
    'tc9c',
    'ts9s',
    'th9h',
    'td9d',
    'kc8c',
    'ks8s',
    'kh8h',
    'kd8d',
    'ac2c',
    'as2s',
    'ah2h',
    'ad2d',
    'kc7c',
    'ks7s',
    'kh7h',
    'kd7d',
    '4c4s',
    '4c4h',
    '4c4d',
    '4s4h',
    '4s4d',
    '4h4d',
    'ac8s',
    'ac8h',
    'ac8d',
    'as8c',
    'as8h',
    'as8d',
    'ah8c',
    'ah8s',
    'ah8d',
    'ad8c',
    'ad8s',
    'ad8h',
    'qcts',
    'qcth',
    'qctd',
    'qstc',
    'qsth',
    'qstd',
    'qhtc',
    'qhts',
    'qhtd',
    'qdtc',
    'qdts',
    'qdth',
    'qc8c',
    'qs8s',
    'qh8h',
    'qd8d',
    'jcts',
    'jcth',
    'jctd',
    'jstc',
    'jsth',
    'jstd',
    'jhtc',
    'jhts',
    'jhtd',
    'jdtc',
    'jdts',
    'jdth',
    'jc8c',
    'js8s',
    'jh8h',
    'jd8d',
    'kc6c',
    'ks6s',
    'kh6h',
    'kd6d',
    '9c8c',
    '9s8s',
    '9h8h',
    '9d8d',
    'tc8c',
    'ts8s',
    'th8h',
    'td8d',
    'kc5c',
    'ks5s',
    'kh5h',
    'kd5d',
    'ac7s',
    'ac7h',
    'ac7d',
    'as7c',
    'as7h',
    'as7d',
    'ah7c',
    'ah7s',
    'ah7d',
    'ad7c',
    'ad7s',
    'ad7h',
    'kc4c',
    'ks4s',
    'kh4h',
    'kd4d',
    'kc9s',
    'kc9h',
    'kc9d',
    'ks9c',
    'ks9h',
    'ks9d',
    'kh9c',
    'kh9s',
    'kh9d',
    'kd9c',
    'kd9s',
    'kd9h',
    'ac5s',
    'ac5h',
    'ac5d',
    'as5c',
    'as5h',
    'as5d',
    'ah5c',
    'ah5s',
    'ah5d',
    'ad5c',
    'ad5s',
    'ad5h',
    '3c3s',
    '3c3h',
    '3c3d',
    '3s3h',
    '3s3d',
    '3h3d',
    'kc3c',
    'ks3s',
    'kh3h',
    'kd3d',
    'ac4s',
    'ac4h',
    'ac4d',
    'as4c',
    'as4h',
    'as4d',
    'ah4c',
    'ah4s',
    'ah4d',
    'ad4c',
    'ad4s',
    'ad4h',
    'qc9s',
    'qc9h',
    'qc9d',
    'qs9c',
    'qs9h',
    'qs9d',
    'qh9c',
    'qh9s',
    'qh9d',
    'qd9c',
    'qd9s',
    'qd9h',
    '8c7c',
    '8s7s',
    '8h7h',
    '8d7d',
    'qc7c',
    'qs7s',
    'qh7h',
    'qd7d',
    'tc7c',
    'ts7s',
    'th7h',
    'td7d',
    'qc6c',
    'qs6s',
    'qh6h',
    'qd6d',
    'kc2c',
    'ks2s',
    'kh2h',
    'kd2d',
    'jc7c',
    'js7s',
    'jh7h',
    'jd7d',
    'ac6s',
    'ac6h',
    'ac6d',
    'as6c',
    'as6h',
    'as6d',
    'ah6c',
    'ah6s',
    'ah6d',
    'ad6c',
    'ad6s',
    'ad6h',
    '9c7c',
    '9s7s',
    '9h7h',
    '9d7d',
    'qc5c',
    'qs5s',
    'qh5h',
    'qd5d',
    'ac3s',
    'ac3h',
    'ac3d',
    'as3c',
    'as3h',
    'as3d',
    'ah3c',
    'ah3s',
    'ah3d',
    'ad3c',
    'ad3s',
    'ad3h',
    'jc9s',
    'jc9h',
    'jc9d',
    'js9c',
    'js9h',
    'js9d',
    'jh9c',
    'jh9s',
    'jh9d',
    'jd9c',
    'jd9s',
    'jd9h',
    'tc9s',
    'tc9h',
    'tc9d',
    'ts9c',
    'ts9h',
    'ts9d',
    'th9c',
    'th9s',
    'th9d',
    'td9c',
    'td9s',
    'td9h',
    '2c2s',
    '2c2h',
    '2c2d',
    '2s2h',
    '2s2d',
    '2h2d',
    'kc8s',
    'kc8h',
    'kc8d',
    'ks8c',
    'ks8h',
    'ks8d',
    'kh8c',
    'kh8s',
    'kh8d',
    'kd8c',
    'kd8s',
    'kd8h',
    'ac2s',
    'ac2h',
    'ac2d',
    'as2c',
    'as2h',
    'as2d',
    'ah2c',
    'ah2s',
    'ah2d',
    'ad2c',
    'ad2s',
    'ad2h',
    'qc4c',
    'qs4s',
    'qh4h',
    'qd4d',
    '7c6c',
    '7s6s',
    '7h6h',
    '7d6d',
    'kc7s',
    'kc7h',
    'kc7d',
    'ks7c',
    'ks7h',
    'ks7d',
    'kh7c',
    'kh7s',
    'kh7d',
    'kd7c',
    'kd7s',
    'kd7h',
    '8c6c',
    '8s6s',
    '8h6h',
    '8d6d',
    '9c6c',
    '9s6s',
    '9h6h',
    '9d6d',
    'jc6c',
    'js6s',
    'jh6h',
    'jd6d',
    'jc5c',
    'js5s',
    'jh5h',
    'jd5d',
    'kc6s',
    'kc6h',
    'kc6d',
    'ks6c',
    'ks6h',
    'ks6d',
    'kh6c',
    'kh6s',
    'kh6d',
    'kd6c',
    'kd6s',
    'kd6h',
    'qc3c',
    'qs3s',
    'qh3h',
    'qd3d',
    'qc2c',
    'qs2s',
    'qh2h',
    'qd2d',
    'tc6c',
    'ts6s',
    'th6h',
    'td6d',
    '6c5c',
    '6s5s',
    '6h5h',
    '6d5d',
    'kc5s',
    'kc5h',
    'kc5d',
    'ks5c',
    'ks5h',
    'ks5d',
    'kh5c',
    'kh5s',
    'kh5d',
    'kd5c',
    'kd5s',
    'kd5h',
    '7c5c',
    '7s5s',
    '7h5h',
    '7d5d',
    'qc8s',
    'qc8h',
    'qc8d',
    'qs8c',
    'qs8h',
    'qs8d',
    'qh8c',
    'qh8s',
    'qh8d',
    'qd8c',
    'qd8s',
    'qd8h',
    '5c4c',
    '5s4s',
    '5h4h',
    '5d4d',
    'jc8s',
    'jc8h',
    'jc8d',
    'js8c',
    'js8h',
    'js8d',
    'jh8c',
    'jh8s',
    'jh8d',
    'jd8c',
    'jd8s',
    'jd8h',
    'jc4c',
    'js4s',
    'jh4h',
    'jd4d',
    'tc8s',
    'tc8h',
    'tc8d',
    'ts8c',
    'ts8h',
    'ts8d',
    'th8c',
    'th8s',
    'th8d',
    'td8c',
    'td8s',
    'td8h',
    '9c8s',
    '9c8h',
    '9c8d',
    '9s8c',
    '9s8h',
    '9s8d',
    '9h8c',
    '9h8s',
    '9h8d',
    '9d8c',
    '9d8s',
    '9d8h',
    '8c5c',
    '8s5s',
    '8h5h',
    '8d5d',
    '9c5c',
    '9s5s',
    '9h5h',
    '9d5d',
    'kc4s',
    'kc4h',
    'kc4d',
    'ks4c',
    'ks4h',
    'ks4d',
    'kh4c',
    'kh4s',
    'kh4d',
    'kd4c',
    'kd4s',
    'kd4h',
    'jc3c',
    'js3s',
    'jh3h',
    'jd3d',
    '6c4c',
    '6s4s',
    '6h4h',
    '6d4d',
    'tc4c',
    'ts4s',
    'th4h',
    'td4d',
    'tc5c',
    'ts5s',
    'th5h',
    'td5d',
    '8c7s',
    '8c7h',
    '8c7d',
    '8s7c',
    '8s7h',
    '8s7d',
    '8h7c',
    '8h7s',
    '8h7d',
    '8d7c',
    '8d7s',
    '8d7h',
    'qc7s',
    'qc7h',
    'qc7d',
    'qs7c',
    'qs7h',
    'qs7d',
    'qh7c',
    'qh7s',
    'qh7d',
    'qd7c',
    'qd7s',
    'qd7h',
    'kc3s',
    'kc3h',
    'kc3d',
    'ks3c',
    'ks3h',
    'ks3d',
    'kh3c',
    'kh3s',
    'kh3d',
    'kd3c',
    'kd3s',
    'kd3h',
    'jc2c',
    'js2s',
    'jh2h',
    'jd2d',
    '7c4c',
    '7s4s',
    '7h4h',
    '7d4d',
    '9c7s',
    '9c7h',
    '9c7d',
    '9s7c',
    '9s7h',
    '9s7d',
    '9h7c',
    '9h7s',
    '9h7d',
    '9d7c',
    '9d7s',
    '9d7h',
    'jc7s',
    'jc7h',
    'jc7d',
    'js7c',
    'js7h',
    'js7d',
    'jh7c',
    'jh7s',
    'jh7d',
    'jd7c',
    'jd7s',
    'jd7h',
    '5c3c',
    '5s3s',
    '5h3h',
    '5d3d',
    'qc6s',
    'qc6h',
    'qc6d',
    'qs6c',
    'qs6h',
    'qs6d',
    'qh6c',
    'qh6s',
    'qh6d',
    'qd6c',
    'qd6s',
    'qd6h',
    'tc3c',
    'ts3s',
    'th3h',
    'td3d',
    'kc2s',
    'kc2h',
    'kc2d',
    'ks2c',
    'ks2h',
    'ks2d',
    'kh2c',
    'kh2s',
    'kh2d',
    'kd2c',
    'kd2s',
    'kd2h',
    '9c4c',
    '9s4s',
    '9h4h',
    '9d4d',
    'tc7s',
    'tc7h',
    'tc7d',
    'ts7c',
    'ts7h',
    'ts7d',
    'th7c',
    'th7s',
    'th7d',
    'td7c',
    'td7s',
    'td7h',
    '8c4c',
    '8s4s',
    '8h4h',
    '8d4d',
    '4c3c',
    '4s3s',
    '4h3h',
    '4d3d',
    '6c3c',
    '6s3s',
    '6h3h',
    '6d3d',
    'qc5s',
    'qc5h',
    'qc5d',
    'qs5c',
    'qs5h',
    'qs5d',
    'qh5c',
    'qh5s',
    'qh5d',
    'qd5c',
    'qd5s',
    'qd5h',
    '8c6s',
    '8c6h',
    '8c6d',
    '8s6c',
    '8s6h',
    '8s6d',
    '8h6c',
    '8h6s',
    '8h6d',
    '8d6c',
    '8d6s',
    '8d6h',
    'tc2c',
    'ts2s',
    'th2h',
    'td2d',
    '9c3c',
    '9s3s',
    '9h3h',
    '9d3d',
    '7c6s',
    '7c6h',
    '7c6d',
    '7s6c',
    '7s6h',
    '7s6d',
    '7h6c',
    '7h6s',
    '7h6d',
    '7d6c',
    '7d6s',
    '7d6h',
    'qc4s',
    'qc4h',
    'qc4d',
    'qs4c',
    'qs4h',
    'qs4d',
    'qh4c',
    'qh4s',
    'qh4d',
    'qd4c',
    'qd4s',
    'qd4h',
    '9c2c',
    '9s2s',
    '9h2h',
    '9d2d',
    '9c6s',
    '9c6h',
    '9c6d',
    '9s6c',
    '9s6h',
    '9s6d',
    '9h6c',
    '9h6s',
    '9h6d',
    '9d6c',
    '9d6s',
    '9d6h',
    '7c3c',
    '7s3s',
    '7h3h',
    '7d3d',
    'jc6s',
    'jc6h',
    'jc6d',
    'js6c',
    'js6h',
    'js6d',
    'jh6c',
    'jh6s',
    'jh6d',
    'jd6c',
    'jd6s',
    'jd6h',
    'qc3s',
    'qc3h',
    'qc3d',
    'qs3c',
    'qs3h',
    'qs3d',
    'qh3c',
    'qh3s',
    'qh3d',
    'qd3c',
    'qd3s',
    'qd3h',
    '5c2c',
    '5s2s',
    '5h2h',
    '5d2d',
    '6c5s',
    '6c5h',
    '6c5d',
    '6s5c',
    '6s5h',
    '6s5d',
    '6h5c',
    '6h5s',
    '6h5d',
    '6d5c',
    '6d5s',
    '6d5h',
    'jc5s',
    'jc5h',
    'jc5d',
    'js5c',
    'js5h',
    'js5d',
    'jh5c',
    'jh5s',
    'jh5d',
    'jd5c',
    'jd5s',
    'jd5h',
    'tc6s',
    'tc6h',
    'tc6d',
    'ts6c',
    'ts6h',
    'ts6d',
    'th6c',
    'th6s',
    'th6d',
    'td6c',
    'td6s',
    'td6h',
    '8c2c',
    '8s2s',
    '8h2h',
    '8d2d',
    '4c2c',
    '4s2s',
    '4h2h',
    '4d2d',
    '8c3c',
    '8s3s',
    '8h3h',
    '8d3d',
    'qc2s',
    'qc2h',
    'qc2d',
    'qs2c',
    'qs2h',
    'qs2d',
    'qh2c',
    'qh2s',
    'qh2d',
    'qd2c',
    'qd2s',
    'qd2h',
    '7c5s',
    '7c5h',
    '7c5d',
    '7s5c',
    '7s5h',
    '7s5d',
    '7h5c',
    '7h5s',
    '7h5d',
    '7d5c',
    '7d5s',
    '7d5h',
    '5c4s',
    '5c4h',
    '5c4d',
    '5s4c',
    '5s4h',
    '5s4d',
    '5h4c',
    '5h4s',
    '5h4d',
    '5d4c',
    '5d4s',
    '5d4h',
    'jc4s',
    'jc4h',
    'jc4d',
    'js4c',
    'js4h',
    'js4d',
    'jh4c',
    'jh4s',
    'jh4d',
    'jd4c',
    'jd4s',
    'jd4h',
    '6c2c',
    '6s2s',
    '6h2h',
    '6d2d',
    '8c5s',
    '8c5h',
    '8c5d',
    '8s5c',
    '8s5h',
    '8s5d',
    '8h5c',
    '8h5s',
    '8h5d',
    '8d5c',
    '8d5s',
    '8d5h',
    '3c2c',
    '3s2s',
    '3h2h',
    '3d2d',
    '9c5s',
    '9c5h',
    '9c5d',
    '9s5c',
    '9s5h',
    '9s5d',
    '9h5c',
    '9h5s',
    '9h5d',
    '9d5c',
    '9d5s',
    '9d5h',
    '7c2c',
    '7s2s',
    '7h2h',
    '7d2d',
    'jc3s',
    'jc3h',
    'jc3d',
    'js3c',
    'js3h',
    'js3d',
    'jh3c',
    'jh3s',
    'jh3d',
    'jd3c',
    'jd3s',
    'jd3h',
    'tc5s',
    'tc5h',
    'tc5d',
    'ts5c',
    'ts5h',
    'ts5d',
    'th5c',
    'th5s',
    'th5d',
    'td5c',
    'td5s',
    'td5h',
    'tc4s',
    'tc4h',
    'tc4d',
    'ts4c',
    'ts4h',
    'ts4d',
    'th4c',
    'th4s',
    'th4d',
    'td4c',
    'td4s',
    'td4h',
    '6c4s',
    '6c4h',
    '6c4d',
    '6s4c',
    '6s4h',
    '6s4d',
    '6h4c',
    '6h4s',
    '6h4d',
    '6d4c',
    '6d4s',
    '6d4h',
    'jc2s',
    'jc2h',
    'jc2d',
    'js2c',
    'js2h',
    'js2d',
    'jh2c',
    'jh2s',
    'jh2d',
    'jd2c',
    'jd2s',
    'jd2h',
    '5c3s',
    '5c3h',
    '5c3d',
    '5s3c',
    '5s3h',
    '5s3d',
    '5h3c',
    '5h3s',
    '5h3d',
    '5d3c',
    '5d3s',
    '5d3h',
    '7c4s',
    '7c4h',
    '7c4d',
    '7s4c',
    '7s4h',
    '7s4d',
    '7h4c',
    '7h4s',
    '7h4d',
    '7d4c',
    '7d4s',
    '7d4h',
    '8c4s',
    '8c4h',
    '8c4d',
    '8s4c',
    '8s4h',
    '8s4d',
    '8h4c',
    '8h4s',
    '8h4d',
    '8d4c',
    '8d4s',
    '8d4h',
    'tc3s',
    'tc3h',
    'tc3d',
    'ts3c',
    'ts3h',
    'ts3d',
    'th3c',
    'th3s',
    'th3d',
    'td3c',
    'td3s',
    'td3h',
    '4c3s',
    '4c3h',
    '4c3d',
    '4s3c',
    '4s3h',
    '4s3d',
    '4h3c',
    '4h3s',
    '4h3d',
    '4d3c',
    '4d3s',
    '4d3h',
    '9c4s',
    '9c4h',
    '9c4d',
    '9s4c',
    '9s4h',
    '9s4d',
    '9h4c',
    '9h4s',
    '9h4d',
    '9d4c',
    '9d4s',
    '9d4h',
    'tc2s',
    'tc2h',
    'tc2d',
    'ts2c',
    'ts2h',
    'ts2d',
    'th2c',
    'th2s',
    'th2d',
    'td2c',
    'td2s',
    'td2h',
    '9c3s',
    '9c3h',
    '9c3d',
    '9s3c',
    '9s3h',
    '9s3d',
    '9h3c',
    '9h3s',
    '9h3d',
    '9d3c',
    '9d3s',
    '9d3h',
    '6c3s',
    '6c3h',
    '6c3d',
    '6s3c',
    '6s3h',
    '6s3d',
    '6h3c',
    '6h3s',
    '6h3d',
    '6d3c',
    '6d3s',
    '6d3h',
    '9c2s',
    '9c2h',
    '9c2d',
    '9s2c',
    '9s2h',
    '9s2d',
    '9h2c',
    '9h2s',
    '9h2d',
    '9d2c',
    '9d2s',
    '9d2h',
    '7c3s',
    '7c3h',
    '7c3d',
    '7s3c',
    '7s3h',
    '7s3d',
    '7h3c',
    '7h3s',
    '7h3d',
    '7d3c',
    '7d3s',
    '7d3h',
    '5c2s',
    '5c2h',
    '5c2d',
    '5s2c',
    '5s2h',
    '5s2d',
    '5h2c',
    '5h2s',
    '5h2d',
    '5d2c',
    '5d2s',
    '5d2h',
    '4c2s',
    '4c2h',
    '4c2d',
    '4s2c',
    '4s2h',
    '4s2d',
    '4h2c',
    '4h2s',
    '4h2d',
    '4d2c',
    '4d2s',
    '4d2h',
    '8c3s',
    '8c3h',
    '8c3d',
    '8s3c',
    '8s3h',
    '8s3d',
    '8h3c',
    '8h3s',
    '8h3d',
    '8d3c',
    '8d3s',
    '8d3h',
    '8c2s',
    '8c2h',
    '8c2d',
    '8s2c',
    '8s2h',
    '8s2d',
    '8h2c',
    '8h2s',
    '8h2d',
    '8d2c',
    '8d2s',
    '8d2h',
    '6c2s',
    '6c2h',
    '6c2d',
    '6s2c',
    '6s2h',
    '6s2d',
    '6h2c',
    '6h2s',
    '6h2d',
    '6d2c',
    '6d2s',
    '6d2h',
    '3c2s',
    '3c2h',
    '3c2d',
    '3s2c',
    '3s2h',
    '3s2d',
    '3h2c',
    '3h2s',
    '3h2d',
    '3d2c',
    '3d2s',
    '3d2h',
    '7c2s',
    '7c2h',
    '7c2d',
    '7s2c',
    '7s2h',
    '7s2d',
    '7h2c',
    '7h2s',
    '7h2d',
    '7d2c',
    '7d2s',
    '7d2h'
  ],
  orderedFiveCardHandIds: [
    'fourOfAKindPlus:royalFlush',
    'fourOfAKindPlus:straightFlush',
    'fourOfAKindPlus:fourOfAKind',
    'fullHouse',
    'flush:nut',
    'flush:secondNut',
    'flush:thirdNut',
    'flush:weak',
    'straight',
    'threeOfAKind:topSet',
    'threeOfAKind:secondSet',
    'threeOfAKind:thirdSet',
    'threeOfAKind:fourthSet',
    'threeOfAKind:middleSet',
    'threeOfAKind:bottomSet',
    'threeOfAKind:trips',
    'twoPair:usingTopBoardCard',
    'twoPair:weak',
    'pair:overpair',
    'pair:tptk',
    'pair:tpgk',
    'pair:tpwk',
    'flushDraw:nut',
    'flushDraw:secondNut',
    'flushDraw:thirdNut',
    'flushDraw:weak',
    'oesd',
    'doubleGutshot',
    'pair:ppUnderTp',
    'pair:secondPair',
    'pair:middlePair',
    'pair:weakPair',
    'gutshot',
    'twoOvercards',
    'oneOvercard',
    'backdoorFlushDraw:nut',
    'backdoorFlushDraw:secondNut',
    'backdoorFlushDraw:thirdNut',
    'backdoorFlushDraw:weak',
    'backdoorStraightDraw',
  ],
};



// WEBPACK FOOTER //
// ./src/services/constants.js